import React, { useState } from "react";
import { BtnHeader } from "./Delivery";
import FormGroup from "../MyPage/FormGroup";
import { useDaumPostcodePopup } from "react-daum-postcode";
import { useForm } from "react-hook-form";
import { useMembership } from "../../hooks/MembershipProvider/MembershipProvider";
import { useAndroidBridge } from "../../hooks/useAndroidBridge";

// 다움 우편번호 API는 동적으로 로드되므로 any 타입 사용

const DeliveryForm = ({ ...props }) => {
  const { formData, navigate, makeBookState, back, projectInfo } = props;
  const { isEmbed } = useMembership();
  const { sendToAndroid, closePostcodePopup } = useAndroidBridge();
  const open = useDaumPostcodePopup();
  // const [formData, setFormData] = useState<any>({});
  const {
    register,
    getValues,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });
  const [defaultChk, setDefaultChk] = useState(false);
  const FormGroup = ({ children }: any) => {
    return <div className={`form_group flex body1_sb mb-5`}>{children}</div>;
  };
  const FormLabel = ({ children, className }: any) => {
    return <div className={`form_label w-[20%] ${className}`}>{children}</div>;
  };
  const FormInput = ({ children, className }: any) => {
    return <div className={`form_input w-[80%] ${className}`}>{children}</div>;
  };
  FormGroup.Label = FormLabel;
  FormGroup.Input = FormInput;

  const handleComplete = (data: any) => {
    if (data.addressType === "R") {
      if (data?.zonecode) {
        setValue(`post_num`, data?.zonecode);
      }
      if (data?.address) {
        setValue("address_1", data?.address);
      }
    }
    console.log(data); // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'

    // 모바일 앱 내 웹뷰에서 주소 선택 후 자동으로 돌아가기
    if (isEmbed()) {
      setTimeout(() => {
        console.log("주소 선택 완료 - Android 브리지를 통해 돌아가기");
        closePostcodePopup();
      }, 500);
    }
  };

  const onHandleSubmit = async () => {
    console.log(`제출`);
    console.log(getValues()?.post_num);
    if (!getValues()?.recipient_name) {
      return alert(`수령인을 입력해주세요.`);
    }
    if (!getValues()?.post_num) {
      return alert(`우편번호를 입력해주세요.`);
    }
    if (!getValues()?.address_1) {
      return alert(`주소를 입력해주세요.`);
    }
    if (!getValues()?.phone_num) {
      return alert(`전화번호를 입력해주세요.`);
    }
    formData({
      recipient_name: getValues()?.recipient_name,
      post_num: getValues()?.post_num,
      address_1: getValues()?.address_1,
      address_2: getValues()?.address_2,
      phone_num: getValues()?.phone_num,
    });
  };

  const getPostCode = async () => {
    console.log(`우편번호 검색`);

    // 모바일 환경 감지
    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    const isEmbedded = isEmbed();

    // 앱 내 웹뷰나 모바일에서는 iframe 방식 우선 사용
    if (isEmbedded || isMobile) {
      console.log("모바일/앱 환경 감지 - iframe 방식 사용");
      openPostcodeInIframe();
      return;
    }

    try {
      // 데스크톱에서는 팝업으로 열기
      await open({
        onComplete: handleComplete,
        alwaysShowEngAddr: false,
        maxSuggestItems: 5,
        showMoreHName: true,
        hideMapBtn: false,
        hideEngBtn: false,
        width: "500px",
        height: "600px",
      });
    } catch (error) {
      console.error("우편번호 검색 팝업 오류:", error);

      // 팝업 실패 시 iframe 방식으로 대체
      console.log("팝업 실패 - iframe 방식으로 대체");
      openPostcodeInIframe();
    }
  };

  // 직접 다움 우편번호 API를 사용한 주소 검색 (모바일 앱 내에서 안정적)
  const openPostcodeInIframe = () => {
    // 기존 오버레이가 있다면 제거
    const existingOverlay = document.getElementById("postcode-overlay");
    if (existingOverlay) {
      existingOverlay.remove();
    }

    // 오버레이 생성
    const overlay = document.createElement("div");
    overlay.id = "postcode-overlay";
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 9999;
      background: white;
      display: flex;
      flex-direction: column;
    `;

    // 닫기 버튼 추가
    const closeButton = document.createElement("div");
    closeButton.innerHTML = "✕";
    closeButton.style.cssText = `
      position: absolute;
      top: 20px;
      right: 20px;
      width: 40px;
      height: 40px;
      background: rgba(0,0,0,0.7);
      color: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      cursor: pointer;
      z-index: 10001;
      user-select: none;
    `;

    // 우편번호 컨테이너
    const postcodeContainer = document.createElement("div");
    postcodeContainer.id = "daum-postcode";
    postcodeContainer.style.cssText = `
      flex: 1;
      width: 100%;
    `;

    overlay.appendChild(closeButton);
    overlay.appendChild(postcodeContainer);
    document.body.appendChild(overlay);

    // 다움 우편번호 API 스크립트 로드
    const loadDaumPostcode = () => {
      if ((window as any).daum && (window as any).daum.Postcode) {
        initializePostcode();
      } else {
        const script = document.createElement("script");
        script.src =
          "https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
        script.onload = initializePostcode;
        script.onerror = () => {
          console.error("다움 우편번호 API 로드 실패");
          overlay.remove();
        };
        document.head.appendChild(script);
      }
    };

    // 우편번호 초기화
    const initializePostcode = () => {
      try {
        if (!(window as any).daum?.Postcode) {
          throw new Error("다움 우편번호 API가 로드되지 않았습니다");
        }
        new (window as any).daum.Postcode({
          oncomplete: function (data: any) {
            console.log("주소 선택됨:", data);
            handleComplete(data);
            overlay.remove();
          },
          onresize: function (size: any) {
            // 크기 조정 시 처리
            console.log("우편번호 크기 조정:", size);
          },
          onclose: function (state: string) {
            // 닫기 시 처리
            if (state === "FORCE_CLOSE") {
              console.log("우편번호 강제 닫기");
            } else if (state === "COMPLETE_CLOSE") {
              console.log("우편번호 완료 후 닫기");
            }
            overlay.remove();
          },
          width: "100%",
          height: "100%",
          maxSuggestItems: 5,
          showMoreHName: true,
          hideMapBtn: true,
          hideEngBtn: true,
          alwaysShowEngAddr: false,
        }).embed(postcodeContainer);
      } catch (error) {
        console.error("우편번호 초기화 실패:", error);
        overlay.remove();
      }
    };

    // 닫기 버튼 이벤트
    closeButton.onclick = () => {
      overlay.remove();
    };

    // ESC 키로 닫기
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        overlay.remove();
        document.removeEventListener("keydown", handleKeyDown);
      }
    };
    document.addEventListener("keydown", handleKeyDown);

    // 오버레이 클릭으로 닫기 (닫기 버튼과 컨테이너 제외)
    overlay.onclick = (e: MouseEvent) => {
      if (e.target === overlay) {
        overlay.remove();
        document.removeEventListener("keydown", handleKeyDown);
      }
    };

    // 다움 우편번호 API 로드
    loadDaumPostcode();
  };

  const defaultUserInfo = async (ev: any) => {
    const { checked, name } = ev.target;
    console.log(checked, "/[checked]");
    if (checked) {
      setValue(`recipient_name`, projectInfo?.user_profile?.name);
      setValue(`phone_num`, projectInfo?.user_profile?.phone_number);
    }
    if (!checked) {
      setValue(`recipient_name`, ``);
      setValue(`phone_num`, ``);
    }
    setDefaultChk(checked);
  };

  return (
    <>
      <div className={`section_wrap sec_wrap_4`}>
        <BtnHeader
          makeBookState={makeBookState}
          back={() => back()}
          navigate={navigate}
        />
        <div className={`sec sec_1 text-center`}>
          <h3 className={`h1`}>배송받을 주소를 입력해주세요.</h3>
        </div>
        <div className={`sec sec_2`}>
          <div className={`flex items-center mb-5`}>
            <div className={`form_group checkbox-container`}>
              <input
                onChange={(ev) => defaultUserInfo(ev)}
                type={`checkbox`}
                id={`default_user_info`}
                name={`default_user_info`}
                className={`user_info_deli`}
              />
              <label
                className={`form_label checkmark`}
                htmlFor={`default_user_info`}
              ></label>
            </div>
            <p className={`ms-3`}>회원 정보와 동일</p>
          </div>
          <div className={`form_box`}>
            {/**---------------------수령인-------------------------**/}
            <FormGroup>
              <FormGroup.Label>수령인</FormGroup.Label>
              <FormGroup.Input>
                <input
                  {...register(`recipient_name`, {required: true})}
                  type={`text`}
                  readOnly={defaultChk}
                  className={`form_control w-[50%] max-md:w-[100%]`}
                />
              </FormGroup.Input>
            </FormGroup>
            {/**---------------------배송지-------------------------**/}
            <FormGroup>
              <FormGroup.Label>배송지</FormGroup.Label>
              <FormGroup.Input>
                <div className={`flex flex-wrap mb-5`}>
                  <input
                    {...register(`post_num`, {required: true})}
                    readOnly
                    type={`text`}
                    className={`form_control w-[50%] max-md:w-[100%]`}
                  />
                  <button
                    onClick={getPostCode}
                    className={`btn md:ms-3 max-md:mt-[10px] post_btn`}
                  >
                    우편번호 검색
                  </button>
                </div>
                <div className={`flex`}>
                  <input
                    {...register(`address_1`, {required: true})}
                    readOnly
                    type={`text`}
                    className={`form_control w-[100%]`}
                  />
                </div>
              </FormGroup.Input>
            </FormGroup>
            {/**---------------------상세주소-------------------------**/}
            <FormGroup>
              <FormGroup.Label>상세주소</FormGroup.Label>
              <FormGroup.Input>
                <input
                  {...register(`address_2`)}
                  type={`text`}
                  className={`form_control w-[100%]`}
                />
              </FormGroup.Input>
            </FormGroup>
            {/**---------------------연락처-------------------------**/}
            <FormGroup>
              <FormGroup.Label>연락처</FormGroup.Label>
              <FormGroup.Input>
                <input
                  {...register(`phone_num`, {required: true})}
                  type={`text`}
                  readOnly={defaultChk}
                  className={`form_control w-[50%] max-md:w-[100%]`}
                />
                <p className={`guide_txt max-md:hidden`}>
                  -자서전 진행 상황은 기존 회원 연락처로 전송됩니다.<br/>
                  -배송받을 분의 연락처를 입력해 주세요.
                </p>
              </FormGroup.Input>
            </FormGroup>
            <p className={`guide_txt md:hidden`}>
              -자서전 진행 상황은 기존 회원 연락처로 전송됩니다.<br/>
              -배송받을 분의 연락처를 입력해 주세요.
            </p>
          </div>
        </div>
        <div className={`footer_btn`}>
          <button
            onClick={onHandleSubmit}
            className={`btn btn-primary block w-[100%] rounded-none`}
          >
            배송지 저장
          </button>
        </div>
      </div>
    </>
  );
};
export default DeliveryForm;
